import { useContext } from 'react';
import { AuthContext } from './AuthContext';
import { AuthContextType } from './AuthTypes';

/**
 * Custom hook to use the Auth context
 * @returns {AuthContextType} Authentication state and methods
 * @throws {Error} If used outside of AuthProvider
 */
export const useAuth = (): AuthContextType => {
  const context = useContext(AuthContext);
  
  if (context === undefined) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  
  return context;
}; 